import _ from '@lodash';
import { Icon, IconButton, TextField, Tooltip, Typography, withStyles } from '@material-ui/core';
import XAPPButton from 'app/Core/Components/Button/XAPPButton';
import * as Helpers from 'app/Core/Helpers';
import MobileDetect from 'mobile-detect';
import React from 'react';
import Toolbar from 'react-big-calendar/lib/Toolbar';

const md = new MobileDetect(window.navigator.userAgent);

const styles = theme => ({
    textField: {
        color: "#FFF !important",
        "& fieldset": {
            borderColor: "#FFF !important",
        },
        "& input": {
            color: "#FFF !important",
        }
    },
});

class SeletorData extends Toolbar {

    state = {
        editable: false,
        date: null,
    }

    componentDidMount() {
        this.setState({ date: this.props.dataBase });
    }

    onChangeEditable = () => {
        this.setState(_.set({ ...this.state }, "editable", !this.state.editable));
    }

    onChangeData = (_AValue) => {
        const { dataBase } = this.props;
        let start = new Date((dataBase + " 00:00:00").replace(/-/g, '/'));
        let newStart = new Date((dataBase + " 00:00:00").replace(/-/g, '/'));
        switch (_AValue) {
            case 1:
            case -1:
                _AValue = new Date(newStart.setMonth(start.getMonth() + _AValue, 1));
                break;
            default:
                _AValue = new Date((_AValue + " 00:00:00").replace(/-/g, '/'));
                break;
        }
        this.props.onChangeDataBase(_AValue.toISOString().substring(0, 10));
    }

    handleChange = (event) => {
        this.setState(_.set({ ...this.state }, event.target.name, event.target.value));
    };

    render() {
        const { classes, dataBase } = this.props;
        return (
            <div className="flex items-center justify-center text-white">
                <React.Fragment>
                    {!this.state.editable &&
                        <Tooltip title="Anterior">
                            <IconButton
                                className="text-white p-6"
                                aria-label="Anterior"
                                onClick={() => this.onChangeData(-1)}
                                disabled={this.state.editable}
                            >
                                <Icon>chevron_left</Icon>
                            </IconButton>
                        </Tooltip>
                    }
                    <React.Fragment>
                        {!this.state.editable ?
                            <div className="cursor-pointer" onClick={() => this.onChangeEditable()}>
                                <Typography className="text-white text-16 whitespace-no-wrap" variant="h6">{Helpers.getLabelIntervaloData(dataBase, dataBase, "month", true)}</Typography>
                            </div>
                            :
                            <div className="flex items-center">
                                <TextField
                                    id="date"
                                    name="date"
                                    type="date"
                                    autoFocus
                                    value={this.state.date}
                                    onChange={this.handleChange}
                                    fullWidth
                                    onKeyPress={(ev) => {
                                        if (ev.key === "Enter") {
                                            this.onChangeData(this.state.date);
                                            this.onChangeEditable();
                                        }
                                    }}
                                    InputLabelProps={{
                                        shrink: true,
                                        className: classes.textField
                                    }}
                                    InputProps={{
                                        className: classes.textField
                                    }}
                                />
                                <XAPPButton
                                    type="Icon"
                                    className=""
                                    onClick={() => {
                                        this.onChangeData(this.state.date);
                                        this.onChangeEditable();
                                    }}
                                    iconProps={"justify-end text-white"}
                                    icon={"done"}
                                    key={"iconNavegarParaData"}
                                />
                            </div>
                        }
                    </React.Fragment>

                    {!this.state.editable &&
                        <Tooltip title="Próximo">
                            <IconButton
                                className="text-white p-6"
                                aria-label="Próximo"
                                onClick={() => this.onChangeData(1)}
                                disabled={this.state.editable}
                            >
                                <Icon>chevron_right</Icon>
                            </IconButton>
                        </Tooltip>
                    }
                </React.Fragment>
            </div>
        )
    };
}

export default withStyles(styles, { withTheme: true })(SeletorData);

